<script setup>
import AsideInsuranceSummary from '@/components/Views/Funnels/voordeelpakket/components/asides/AsideInsuranceSummary.vue';
import { pakketStore } from '@/stores/pakket.js';

const pakket = pakketStore();
</script>

<template>
  <aside v-if="pakket.totaalpremie">
    <h2 class="h3">
      {{ $t(`summary.voordeelpakket.sidebar-title`) }}
    </h2>
    <div class="content">
      <!-- Google maps integration -->
      <AsideInsuranceSummary />
    </div>
  </aside>
</template>

<style scoped lang="scss">
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

aside {
  @include media-breakpoint-up(lg) {
    padding-top: 1.6rem;
    padding-left: 3.2rem;

    h2 {
      padding-bottom: 1.1rem;
    }
  }

  .content {
    border: 1px solid var(--theme-font-color-25);
    border-radius: 1.6rem;
    margin-bottom: 0.8rem;
  }
}
</style>
